// Utils to clean logs and event types
//   - We just want user to see events in logs and event type filters as QA_<X>
//   - Trim any prefix off logs and pass it back
//   * There are some "extra" event types in dev that need to be filtered out. can possibly look at removing these

import { cloneDeep, uniqBy } from 'lodash'

const trimPrefix = (message: any) => {
  const re = /(qa_\w+)/i
  const res = message.match(re)

  return res ? res[0] : message
}

export const cleanLogEventTypes = (logs: any) => {
  return logs.map((log: any) => {
    const clone = cloneDeep(log)
    clone.message = trimPrefix(log.message)
    clone.data.event = trimPrefix(log.data.event)

    return clone
  })
}

export const cleanEventTypes = (eventtypes: any) => {
  return uniqBy(
    eventtypes
      .filter((et: any) => et.key.startsWith('KNOWLEDGE_'))
      .map((et: any) => {
        const clone = cloneDeep(et)
        clone.key = trimPrefix(et.key)
        clone.value = et.key

        return clone
      }),
    'key'
  )
}
